/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiExternalEntityStatus;
(function (ApiExternalEntityStatus) {
    ApiExternalEntityStatus["EXTERNAL_ENTITY_STATUS_UNSPECIFIED"] = "ExternalEntityStatusUnspecified";
    ApiExternalEntityStatus["EXTERNAL_ENTITY_STATUS_ACTIVE"] = "ExternalEntityStatusActive";
    ApiExternalEntityStatus["EXTERNAL_ENTITY_STATUS_DRAFT"] = "ExternalEntityStatusDraft";
    ApiExternalEntityStatus["EXTERNAL_ENTITY_STATUS_PAUSED"] = "ExternalEntityStatusPaused";
})(ApiExternalEntityStatus || (ApiExternalEntityStatus = {}));
export function ApiExternalEntityStatusFromJSON(json) {
    return ApiExternalEntityStatusFromJSONTyped(json, false);
}
export function ApiExternalEntityStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiExternalEntityStatusToJSON(value) {
    return value;
}
